import React, { useState } from "react";
import { ABtn, AResult } from "./arcadeUi";

const LINES = [[0,1,2],[3,4,5],[6,7,8],[0,3,6],[1,4,7],[2,5,8],[0,4,8],[2,4,6]];
const winner = (b) => { for (const [a,c,d] of LINES) if (b[a] && b[a] === b[c] && b[a] === b[d]) return b[a]; return b.every(Boolean) ? "draw" : null; };

// minimax: CPU is "O", player "X"
const best = (b) => {
  const w = winner(b);
  if (w === "O") return { score: 1 };
  if (w === "X") return { score: -1 };
  if (w === "draw") return { score: 0 };
  let move = null;
  let bestScore = -Infinity;
  for (let i = 0; i < 9; i++) {
    if (!b[i]) {
      b[i] = "O";
      const s = -negamax(b, "X");
      b[i] = null;
      if (s > bestScore) { bestScore = s; move = i; }
    }
  }
  return { move, score: bestScore };
};
const negamax = (b, player) => {
  const w = winner(b);
  if (w === "draw") return 0;
  if (w) return w === player ? 1 : -1;
  let bestScore = -Infinity;
  for (let i = 0; i < 9; i++) {
    if (!b[i]) {
      b[i] = player;
      const s = -negamax(b, player === "X" ? "O" : "X");
      b[i] = null;
      if (s > bestScore) bestScore = s;
    }
  }
  return bestScore;
};

export default function TicTacToe() {
  const [b, setB] = useState(Array(9).fill(null));
  const [lock, setLock] = useState(false);
  const w = winner(b);

  const play = (i) => {
    if (b[i] || w || lock) return;
    const nb = b.slice(); nb[i] = "X"; setB(nb);
    if (winner(nb)) return;
    setLock(true);
    setTimeout(() => {
      const { move } = best(nb.slice());
      if (move != null) { const nb2 = nb.slice(); nb2[move] = "O"; setB(nb2); }
      setLock(false);
    }, 350);
  };

  return (
    <div className="w-full text-center">
      <p className="mb-3 text-sm text-kirana-brown/70">Kaate (X) vs Zero (O) — you're ❌, beat the CPU ⭕ (good luck, it plays perfectly!).</p>
      <div className="mx-auto grid w-full max-w-[280px] grid-cols-3 gap-2" data-testid="ttt-board">
        {b.map((v, i) => (
          <button key={i} data-testid={`ttt-cell-${i}`} onClick={() => play(i)}
            className="flex aspect-square items-center justify-center rounded-md border-[3px] border-kirana-brown bg-white font-signboard text-4xl font-bold text-kirana-brown transition-colors hover:bg-kirana-cream">
            <span className={v === "X" ? "text-kirana-red" : "text-kirana-green"}>{v}</span>
          </button>
        ))}
      </div>
      {w && (
        <>
          <AResult testId="ttt-result" win={w === "X" ? true : w === "draw" ? null : false}
            text={w === "X" ? "You Win! 🎉" : w === "draw" ? "It's a Draw 🤝" : "CPU Wins 😜"} />
          <div className="mt-3 flex justify-center"><ABtn data-testid="ttt-again" onClick={() => setB(Array(9).fill(null))} tone="green">Play Again</ABtn></div>
        </>
      )}
    </div>
  );
}
